import { axios } from '../../../utils/api/axiosConfig';

const apiRoutes = require('../../../utils/api/apiRouteConfig');

export function getStateStore(caseId, quoteId) {
    return new Promise((resolve, reject) => {
        axios.get('/session/samx-token').then(({ data }) => data?.token || '').catch(() => '').then((samxToken) => axios.get(`${apiRoutes.mongo}/stateStore/${caseId}/${quoteId}`, { headers: { Authorization: `Bearer ${samxToken}` } }))
            .then((resp) => {
                resolve(resp.data);
            }).catch((err) => {
                console.log('Error', err);
                reject();
            });
    });
}

export function getStateStoreForChtBot(caseId, memId) {
    return new Promise((resolve, reject) => {
        axios.get(`${apiRoutes.mongo}/stateStore/chatBot/${caseId}/${memId}`)
            .then((resp) => {
                resolve(resp.data);
            }).catch((err) => {
                console.log('Error', err);
                reject();
            });
    });
}